module.exports = __webpack_public_path__ + "static/img/location_pic.9169199.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/aboutus/location_pic.png
// module id = aGez
// module chunks = 44